<nz-layout
  class="main-layout"
  [class.bottom-padding]="publicMainLayoutService.bottomPanel()"
>
  <math-header />

  <nz-content class="content">
    <router-outlet />
  </nz-content>
  @if (publicMainLayoutService.bottomPanel()) {
    <div
      class="bottom-panel"
      [class.slide-up]="publicMainLayoutService.bottomPanelVisible()"
      [class.slide-down]="!publicMainLayoutService.bottomPanelVisible()"
    >
      <ng-container *ngTemplateOutlet="publicMainLayoutService.bottomPanel()" />
    </div>
  }
</nz-layout>
